//孟加拉
export default { 
 common: { 
 unit: 'USDT', 
 day: 'দিন', 
 week: 'সপ্তাহ', 
 save: 'সংরক্ষণ করুন', 
 submit: 'জমা দিন', 
 confirmtitle: 'অপারেশন নিশ্চিত করুন', 
 confirm: 'নিশ্চিত করুন', 
 reset: 'রিসেট করুন', 
 refresh: 'রিফ্রেশ করুন', 
 copy: 'কপি করুন', 
 copysuccessful: 'কপি সফল', 
 modify: 'সংশোধন করুন', 
 binding: 'বাইন্ড করুন', 
 finished: 'সম্পন্ন হয়েছে', 
 canceled: 'বাতিল হয়েছে', 
 cancel: 'বাতিল করুন', 
 all: 'সব', 
 back: 'ফিরে যান', 
 loading: 'লোডিং হচ্ছে...', 
 nomore: 'সব রেকর্ড', 
 errortxt: 'লোডিং ব্যর্থ', 
 loosing: 'সলানী করুন রিফ্রেশ করতে...', 
 pulling: 'ড্রাগ ডাউন করুন রিফ্রেশ করতে...', 
 nodata: 'কোন রেকর্ড নেই', 
 buy: 'ক্রয় করুন', 
 buyup: 'বৃদ্ধি ক্রয় করুন', 
 buydown: 'কম ক্রয় করুন', 
 sell: 'বিক্রয় করুন', 
 forserver: 'সার্ভারের সাথে যোগাযোগ করুন', 
 total: 'মোট', 
 status1: 'পরীক্ষা পেন্ডিং', 
 status2: 'সম্পন্ন', 
 status3: 'ফাইল', 
 paytype1:'TRC20', 
 paytype2: 'ERC20', 
 paytype3: 'ইলেকট্রনিক ট্রান্সফার', 
 }, 
 footer: { 
 home: 'হোম', 
 market: 'বাজার', 
 exchange: 'ক্রিপ্টো ট্রেডিং', 
 options: 'অপশন', 
 assets:'সম্পদ', 
 change: 'ট্রান্সফার', 
 recharge: 'ক্রিপ্টো রিচার্জ', 
 withdrawal: 'উত্তোলন' 
 }, 
 home: { 
 menu1:'অপশন ট্রেডিং', 
 menu1desc: 'BTC/USDT ইত্যাদি সমর্থিত', 
 menu2: 'দ্রুত রিচার্জ', 
 menu3: 'উত্তোলন', 
 menu4: 'লাইভ কস্টমার সার্ভিস', 
 menu5: 'দ্রুত বিনিময়', 
 menu6: 'লোন সাহায্য', 
 menu7: 'সিক্যুরিটি মাইনিং', 
 menu8: 'স্টেকিং', 
 menu9: 'অ্যাকাউন্ট ট্রান্সফার', 
 ranktitle: 'গণিতের সূচক', 
 name: 'নাম', 
 price: 'সর্বশেষ মূল্য', 
 risefall: 'বৃদ্ধি/পতন', 
 }, 
 register: { 
 register: 'রেজিস্টার করুন', 
 login: 'লগইন করুন', 
 email: 'ইমেইল', 
 phone: 'ফোন নম্বর', 
 accountplaceholder: 'অ্যাকাউন্ট নম্বর দিন', 
 emailplaceholder: 'ইমেইল দিন', 
 phoneplaceholder: 'ফোন নম্বর দিন', 
 pwdplaceholder:'পাসওয়ার্ড দিন', 
 pwdplaceholder1:'পাসওয়ার্ড ৬-২০ অক্ষরের মধ্যে হতে হবে', 
 agepwdplaceholder: 'পাসওয়ার্ড আবার দিন', 
 agepwdplaceholder1: 'দুইবার পাসওয়ার্ড ভিন্ন', 
 invitecodeplaceholder: 'ইনভাইট কোড দিন', 
 remember: 'পাসওয়ার্ড মনে রাখুন', 
 fotget: 'পাসওয়ার্ড ভুলে গেছেন' 
 }, 
 market:{ 
 title: 'বাজার', 
 all: 'সব' 
 }, 
 member:{ 
 reputation:'রেপুটেশন স্কোর', 
 identity_authentication:'আইডেন্টিটি যাচাইকরণ', 
 under_review:'পরীক্ষায়', 
 certified:'সার্টিফাইড', 
 awaiting_certification:'সার্টিফিকেশন পেন্ডিং', 
 binding_withdrawal_address: 'উত্তোলন ঠিকানা বাইন্ড করুন', 
 currently_selected_currency:'বর্তমান নির্বাচিত মুদ্রা', 
 withdrawal_address:'উত্তোলন ঠিকানা', 
 sharing_link:'আমার শেয়ার লিঙ্ক', 
 my_promotion_code:'আমার প্রমোশন কোড', 
 promotion_code:'প্রমোশন কোড', 
 system_message:'সিস্টেম বার্তা', 
 night_mode:'নাইট মোড', 
 security_center:'সিকিউরিটি সেন্টার', 
 seted: 'সেট করা হয়েছে', 
 noset: 'সেট করা হয়নি', 
 login_password:'লগইন পাসওয়ার্ড', 
 transaction_password:'উত্তোলন পাসওয়ার্ড', 
 app_download:'অ্যাপ ডাউনলোড', 
 log_out:'লগ আউট করুন', 
 aboutus: 'ওয়েবসাইটের বিবরণ' 
 }, 
 identity:{ 
 title: 'আইডেন্টিটি যাচাইকরণ', 
 name: 'নাম', 
 nameplaceholder: 'সত্যিকার নাম দিন', 
 uploader: 'আইডি কার্ড ছবি আপলোড করুন', 
 tip1: 'আইডি কার্ড প্রথম পৃষ্ঠা আপলোড করুন', 
 tip2: 'আইডি কার্ড দ্বিতীয় পৃষ্ঠা আপলোড করুন' 
 }, 
 address: { 
 title: 'উত্তোলন ঠিকানা বাইন্ড করুন', 
 bType: 'বর্তমান নির্বাচিত মুদ্রা', 
 address: 'উত্তোলন ঠিকানা', 
 addressplaceholder:'উত্তোলন ঠিকানা দিন', 
 }, 
 security:{ 
 title: 'সিকিউরিটি সেন্টার', 
 modifypwd: 'লগইন পাসওয়ার্ড', 
 resetlegalpwd: 'ট্রান্সফার পাসওয়ার্ড', 
 loginpwd: 'নতুন লগইন পাসওয়ার্ড', 
 pwdage: 'পাসওয়ার্ড পুনরায় দিন', 
 loginpwdplaceholder:'বর্তমান লগইন পাসওয়ার্ড দিন', 
 loginnewpwdplaceholder: 'নতুন লগইন পাসওয়ার্ড দিন', 
 moneypwd: 'ট্রান্সফার পাসওয়ার্ড দিন', 
 pwdageplaceholder:'পাসওয়ার্ড পুনরায় দিন' 
 }, 
 trade:{ 
 title: 'ক্রিপ্টো ট্রেডিং', 
 price: 'মূল্য', 
 num: 'সংখ্যা', 
 entrust: 'বর্তমান কমিশন', 
 clinch: 'প্রকৃত লেনদেন', 
 used: 'ব্যবহারযোগ্য', 
 buyed: 'ক্রয় করা যাবে', 
 amount: 'লেনদেনের পরিমাণ', 
 limitprice: 'সীমা মূল্য', 
 marketprice: 'বাজার মূল্য', 
 forprice: 'বর্তমান সর্বোত্তম মূল্যে লেনদেন করুন', 
 errorMoney: 'ব্যবহারযোগ্য ব্যালেন্স নেই', 
 priceerror: 'কমিশন মূল্য দিন', 
 numerror: 'কমিশন সংখ্যা দিন', 
 moneyerror: 'কমিশন পরিমাণ দিন', 
 }, 
 assets:{ 
 allconvert:'সর্বসম্পদ মুদ্রা রূপান্তর', 
 usenum: 'ব্যবহারযোগ্য', 
 freeze: 'ফ্রিজ', 
 convert: 'রূপান্তর', 
 tab1:'সম্পদ', 
 tab11: 'সর্বসম্পদ রূপান্তর', 
 tab12: 'অপশন রূপান্তর', 
 tab13: 'পুঁজি রূপান্তর', 
 tab14: 'কোয়ান্টাইজেশন রূপান্তর', 
 tab2:'অপশন', 
 tab21: 'অপশন অ্যাকাউন্ট', 
 tab3:'পুঁজি', 
 tab31:'পুঁজি অ্যাকাউন্ট', 
 tab4:'কোয়ান্টাইজেশন', 
 tab41:'কোয়ান্টাইজেশন অ্যাকাউন্ট', 
 tbhead1: 'ফাইনান্সিয়াল রেকর্ড', 
 tbhead2: 'উত্তোলন রেকর্ড', 
 tbhead3: 'রিচার্জ রেকর্ড', 
 tbhead4: 'ট্রান্সফার রেকর্ড', 
 rcdnum: 'সংখ্যা', 
 rcd: 'রেকর্ড', 
 rcdtime: 'সময়' , 
 rcdstatus: 'স্ট্যাটাস', 
 rcddesc: 'বিবরণ', 
 rcdaddress: 'রিচার্জ ঠিকানা' 
 }, 
 change:{ 
 title: 'ট্রান্সফার', 
 from: 'থেকে {name}', 
 to: 'থেকে {name}', 
 frmtitle: 'ট্রান্সফার সংখ্যা', 
 inputplaceholder: 'ট্রান্সফার সংখ্যা দিন', 
 btntxt:'ট্রান্সফার করুন' 
 }, 
 recharge:{ 
 title: 'ক্রিপ্টো রিচার্জ', 
 bType: 'বর্তমান মুদ্রা', 
 address: 'রিচার্জ ঠিকানা', 
 token: 'পেমেন্ট প্রমাণপত্র', 
 tokenplaceholder: 'পেমেন্ট প্রমাণপত্র আপলোড করুন', 
 num: 'রিচার্জ পরিমাণ', 
 numplaceholder: 'পরিমাণ দিন', 
 btn: 'পরীক্ষা জমা দিন', 
 bankname: 'ব্যাংক নাম', 
 bankno: 'ব্যাংক নম্বর', 
 accountname: 'ব্যাক্তিগত অ্যাকাউন্ট নাম', 
 bankaddress: 'ব্যাংক ঠিকানা', 
 bankcode: 'ব্যাংক ট্রান্সফার কোড', 
 companyaddress: 'কোম্পানির ঠিকানা' 
 }, 
 withdrawal:{ 
 title:'উত্তোলন', 
 frmtitle1: 'সংখ্যা', 
 frmplaceholder1: 'উত্তোলন সংখ্যা {min} - {max} এর মধ্যে', 
 frmtitle2: 'ট্রান্সফার পাসওয়ার্ড', 
 frmplaceholder2: 'ট্রান্সফার পাসওয়ার্ড দিন', 
 getnum: 'প্রাপ্ত পরিমাণ', 
 fee:'ফি', 
 btn: 'উত্তোলন করুন' 
 }, 
 exchangeb:{ 
 title: 'বিনিময়', 
 account: 'অ্যাকাউন্ট', 
 btn: 'বিনিময় করুন', 
 numerror: 'বিনিময় সংখ্যা দিন' 
 }, 
 option:{ 
 title: 'অপশন', 
 typetitle: 'সেকেন্ড কন্ট্রাক্ট', 
 listtitle: 'পোজিশন হোল্ড', 
 kline: 'কেলাইন', 
 high: 'উচ্চ', 
 low: 'নিম্ন', 
 nums: '২৪ ঘন্টা পরিমাণ', 
 time: 'সময়', 
 transaction: 'লেনদেন মোড', 
 quantity: 'পোজিশন পরিমাণ', 
 quantityerror: 'পোজিশন পরিমাণ দিন', 
 times: 'পোজিশন সময়', 
 times1: 'নিষ্পত্তির সময়',
 account: 'অ্যাকাউন্ট ব্যালেন্স', 
 buyup:'বৃদ্ধি ক্রয় করুন', 
 buydown: 'কম ক্রয় করুন', 
 tab1: 'পোজিশন হোল্ড লিস্ট', 
 tab2: 'অর্ডার রেকর্ড', 
 num: 'সংখ্যা', 
 price1: 'ক্রয় মূল্য', 
 price2: 'বিক্রয় মূল্য', 
 profitandloss: 'প্রতিনিধিত্ব লাভ/লোকসান', 
 profitandloss1: 'লাভ/লোকসান', 
 countdown: 'কাউন্টডাউন', 
 waitfinish: 'সমাপ্তি পেন্ডিং', 
 finishing: 'সমাপ্তি চলছে...', 
 finished: 'সমাপ্ত হয়েছে', 
 order_price: 'বর্তমান মূল্য', 
 order_cycle: 'চক্র', 
 order_type: 'প্রকার', 
 order_money: 'পরিমাণ', 
 order_time: 'পোজিশন স্থাপন', 
 order_get: 'লাভ', 
 order_btn: 'আরও অর্ডার দিন' 
 }, 
 tradelst:{ 
 title: 'আমার কমিশন', 
 tab1: 'কমিশন', 
 tab2: 'লেনদেন সম্পন্ন', 
 tab3: 'বাতিল করা হয়েছে', 
 usdtnum: '' 
 }, 
 loans:{ 
 title: 'লোন সাহায্য', 
 order_tab: 'লোন অর্ডার', 
 pro_tab: 'লোন পণ্য', 
 
 Institution:'লেনার সংস্থা', 
 Amount: 'পরিমাণ', 
 DailyInterest:'দৈনিক সুদের হার', 
 RepaymentPeriod:'ঋণ পরিশোধের সময়কাল', 
 Application: 'লোন আবেদন করুন', 
 orderno: 'অর্ডার নম্বর', 
 AllInterest: 'সর্বমোট সুদ', 
 RepaymentDate:'ঋণ পরিশোধের তারিখ', 
 RepaymentMethod: 'ঋণ পরিশোধ পদ্ধতি', 
 Onetime: 'একসাথে', 
 Expected_loan_amount:'আশা করা ঋণ পরিমাণ', 
 Expected_loan_amounterror:'ঋণ পরিমাণ {min} - {max} এর মধ্যে হতে হবে', 
 imgplaceholdr: 'ক্রেডিট লোন (চিত্রটি পরিষ্কারভাবে দৃশ্যমান থাকতে হবে)', 
 icon1: 'সনদ সম্মুখ পৃষ্ঠা আপলোড করুন', 
 icon2: 'সনদ পিছন পৃষ্ঠা আপলোড করুন', 
 icon3: 'হ্যান্ডহেল্ড সনদ আপলোড করুন', 
 status1: 'আবেদন চলছে', 
 status2: 'আবেদন স্বীকৃত', 
 status3: 'আবেদন ব্যর্থ', 
 }, 
 lockming:{ 
 title: 'সিক্যুরিটি মাইনিং', 
 order_tab: 'মাইনিং অর্ডার', 
 pro_tab: 'মাইনিং মার্কেট', 
 locknum: 'সর্বনিম্ন লক পরিমাণ', 
 getforday: 'রোজগার হার/দিন', 
 days: 'দিন', 
 estimation: 'অনুমানিক আয়', 
 real: 'আয় হয়েছে', 
 balance: 'ওয়ালেট ব্যালেন্স', 
 nums: 'লক পরিমাণ', 
 tolockming: 'লক করুন', 
 stime: 'শুরু সময়', 
 etime: 'সমাপ্তি সময়', 
 }, 
 transfer:{ 
 title: 'অ্যাকাউন্ট ট্রান্সফার', 
 searchtxt: 'প্রাপকের অ্যাকাউন্ট দিন', 
 ReceivingAccount: 'প্রাপকের অ্যাকাউন্ট তথ্য', 
 toaccount: 'অ্যাকাউন্ট', 
 confirmtxt: 'প্রাপকের অ্যাকাউন্ট নিশ্চিত করুন', 
 confirmedtxt: 'অ্যাকাউন্ট নিশ্চিত হয়েছে', 
 numtxt: 'ট্রান্সফার পরিমাণ', 
 numerror: 'ট্রান্সফার পরিমাণ দিন', 
 fee: 'অভ্যন্তরীণ ট্রান্সফার ফি নেই', 
 ArrivalTime: 'প্রাপ্তির সময়', 
 Immediately: 'অবিলম্বে উপস্থিত হবে', 
 realnum: 'প্রকৃত প্রাপ্তির পরিমাণ', 
 btn: 'ট্রান্সফার নিশ্চিত করুন', 
 
 transfering: 'ট্রান্সফার চলছে', 
 orderNo: 'অর্ডার নম্বর', 
 stime: 'ট্রান্সফার সময়', 
 etime: 'প্রাপ্তির সময়', 
 receiving: 'প্রাপক অ্যাকাউন্ট', 
 type: 'মুদ্রা', 
 num: 'ট্রান্সফার পরিমাণ', 
 arrivalnum: 'প্রাপ্তির পরিমাণ' 
 }, 
 staking:{ 
 title: 'স্টেকিং', 
 record: 'রেকর্ড', 
 getforyear: 'সালের জন্য রেফারেন্স আয় হার', 
 time: 'বিনিয়োগ সময়কাল', 
 snum: 'সর্বনিম্ন বিনিয়োগ পরিমাণ', 
 snumerror: 'সর্বনিম্ন বিনিয়োগ পরিমাণ দিন', 
 snumerror1: 'সর্বনিম্ন বিনিয়োগ পরিমাণ {num} এর কম নয়', 
 join: 'অবিলম্বে অংশগ্রহণ করুন', 
 opentime: 'পোজিশন স্থাপনের সময়', 
 money: 'বিনিয়োগ পরিমাণ', 
 days: 'চক্র', 
 recordget: 'সালের আয় হার', 
 gets: 'আয়', 
 stime: 'সূচনা তারিখ', 
 etiem: 'সমাপ্তি তারিখ', 
 redeemStaking: 'প্রত্যাহার করুন', 
 status0: 'স্টেকিং চলছে', 
 status1: 'অর্ডার শেষ হয়েছে', 
 status2: 'অর্ডার প্রত্যাহার হয়েছে', 
 }, 
 bank:{ 
 title: 'ব্যাংক কার্ড বাইন্ড করুন', 
 bankName: 'ব্যাংক নাম', 
 bankNameError: 'ব্যাংক নাম দিন', 
 usrName: 'কার্ডধারক নাম', 
 usrNameError: 'কার্ডধারক নাম দিন', 
 cardCode: 'ব্যাংক কার্ড নম্বর', 
 cardCodeError: 'ব্যাংক কার্ড নম্বর দিন', 
 towallet: 'ওয়ালেটে উত্তোলন করুন', 
 tobank: 'ব্যাংকে উত্তোলন করুন', 
 sendcode: 'কোড পাঠান', 
 sended: '{num} সেকেন্ড পরে পুনরায় পাঠান', 
 verify_code: 'ইমেইল কোড দিন' 
 } 
}
